import { HttpClient } from "@angular/common/http";
import { environment as env } from "../../../../../environments/environment.prod";
import { Injectable } from "@angular/core";
import { AbstractService } from "app/services/abstract.service";
import { Observable } from "rxjs";
import { IAPIListResult, IPagination, IPaginationResult } from "app/common/interfaces";
import PaymentSalesOfficeAccountingAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/payment-masters/payment-type/payment-sales-office-accounting/payment-sales-office-accounting.entity";
import { PayloadAccountSalesBasic } from "../account-sales/interfaces/account-sales.interface";

const apiUrl = env.API_PAYMENT_MASTER_URL;
const moduleName = "payment_type_sales_office_accounting";

@Injectable({
  providedIn: "root",
})
export class PaymentTypeSalesOfficeService extends AbstractService<
  PaymentSalesOfficeAccountingAttributes, 
  PayloadAccountSalesBasic, 
  PayloadAccountSalesBasic> {

  constructor(
    http: HttpClient,
  ) {
    super(apiUrl, moduleName, http);
  }

  getAllList(brandId: string): Observable<IAPIListResult<PaymentSalesOfficeAccountingAttributes>> {
    const API_URL: string = apiUrl + `api/${moduleName}/${brandId}`;
    return this.http.get<IAPIListResult<PaymentSalesOfficeAccountingAttributes>>(API_URL);
  }
}
